/**
 * An error that carries navigation context for the ErrorBoundary.
 * When caught, the boundary renders a custom button that navigates
 * to the specified route instead of the default "Try Again".
 */
export class NavigableError extends Error {
  readonly to: string;
  readonly search?: Record<string, unknown>;
  readonly buttonLabel: string;

  constructor({
    message,
    to,
    search,
    buttonLabel,
  }: {
    message: string;
    to: string;
    search?: Record<string, unknown>;
    buttonLabel: string;
  }) {
    super(message);
    this.name = 'NavigableError';
    this.to = to;
    this.search = search;
    this.buttonLabel = buttonLabel;
  }
}
